import {
  Component, Inject, Injector, forwardRef, ElementRef, OnInit,
  Optional,
  NgModule,
  ViewEncapsulation
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { ValidatorFn } from '@angular/forms/src/directives/validators';
import { OSharedModule } from '../../../shared';
import { OFormComponent } from '../../form/o-form.component';
import {
  ORealInputModule, ORealInputComponent,
  DEFAULT_INPUTS_O_REAL_INPUT, DEFAULT_OUTPUTS_O_REAL_INPUT
} from '../real-input/o-real-input.component';

export const DEFAULT_INPUTS_O_CURRENCY_INPUT = [
  ...DEFAULT_INPUTS_O_REAL_INPUT,
  'currencySymbol: currency-symbol',
  'currencySymbolPosition: currency-symbol-position'
];

export const DEFAULT_OUTPUTS_O_CURRENCY_INPUT = [
  ...DEFAULT_OUTPUTS_O_REAL_INPUT
];


export class OCurrencyInputComponent extends ORealInputComponent implements OnInit {

  public static DEFAULT_INPUTS_O_CURRENCY_INPUT = DEFAULT_INPUTS_O_CURRENCY_INPUT;
  public static DEFAULT_OUTPUTS_O_CURRENCY_INPUT = DEFAULT_OUTPUTS_O_CURRENCY_INPUT;

  currency_symbols = {
    'USD': '$', // US Dollar
    'EUR': '€', // Euro
    'CRC': '₡', // Costa Rican Colón
    'GBP': '£', // British Pound Sterling
    'ILS': '₪', // Israeli New Sheqel
    'INR': '₹', // Indian Rupee
    'JPY': '¥', // Japanese Yen
    'KRW': '₩', // South Korean Won
    'NGN': '₦', // Nigerian Naira
    'PHP': '₱', // Philippine Peso
    'PLN': 'zł', // Polish Zloty
    'PYG': '₲', // Paraguayan Guarani
    'THB': '฿', // Thai Baht
    'UAH': '₴', // Ukrainian Hryvnia
    'VND': '₫', // Vietnamese Dong
  };

  currencySymbol: string = 'EUR';
  currencySymbolPosition: string = 'right';

  constructor(
      form: OFormComponent,
    elRef: ElementRef,
    injector: Injector) {
    super(form, elRef, injector);
  }

  resolveValidators(): ValidatorFn[] {
    let validators: ValidatorFn[] = super.resolveValidators();
    return validators;
  }

static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'o-currency-input',
  template: `
    <div fxLayout="row" fxLayoutAlign="space-between center" [formGroup]="getFormGroup()" [mdTooltip]="tooltip" [mdTooltipPosition]="tooltipPosition"
        [mdTooltipShowDelay]="tooltipShowDelay">
        <span *ngIf="currencySymbol !== 'none' && currencySymbolPosition === 'left'" mdSuffix [class.mat-disabled]="isDisabled" class="icon-btn">{{ currency_symbols[currencySymbol] }}</span>
        <md-form-field #innerInputContainer fxFill>
            <input mdInput type="number" [attr.id]="getAttribute()" [formControlName]="getAttribute()" [placeholder]="placeHolder" [ngModel]="getValue()"
                (ngModelChange)="innerOnChange($event)" (focus)="innerOnFocus($event)" (blur)="innerOnBlur($event)" [readonly]="isReadOnly"
                [min]="min" [max]="max" [step]="step">
            <span *ngIf="currencySymbol !== 'none' && currencySymbolPosition === 'right' " mdSuffix [class.mat-disabled]="isDisabled"
                class="icon-btn">{{ currency_symbols[currencySymbol] }}</span>
            <md-error *ngIf="hasError('required')">{{ 'FORM_VALIDATION.REQUIRED' | oTranslate }}</md-error>
            <md-error *ngIf="hasError('min')">{{ 'FORM_VALIDATION.MIN_VALUE' | oTranslate }}: {{ getErrorValue('min', 'requiredMin') }}</md-error>
            <md-error *ngIf="hasError('max')">{{ 'FORM_VALIDATION.MAX_VALUE' | oTranslate }}: {{ getErrorValue('max', 'requiredMax') }}</md-error>
            <md-error *ngIf="hasError('pattern')">{{ 'FORM_VALIDATION.FORMAT' | oTranslate }}</md-error>

        </md-form-field>

    </div>
  `,
  styles: [`
    o-currency-input input{padding-right:8px}o-currency-input input .mat-input-wrapper .mat-input-table .mat-input-infix .mat-input-element{text-align:end}
  `],
  inputs: [
    ...DEFAULT_INPUTS_O_CURRENCY_INPUT
  ],
  outputs: [
    ...DEFAULT_OUTPUTS_O_CURRENCY_INPUT
  ],
  encapsulation: ViewEncapsulation.None
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: OFormComponent, decorators: [{ type: Optional }, { type: Inject, args: [forwardRef(() => OFormComponent), ] }, ]},
{type: ElementRef, },
{type: Injector, },
];
}


export class OCurrencyInputModule {
static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  declarations: [OCurrencyInputComponent],
  imports: [OSharedModule, CommonModule, ORealInputModule],
  exports: [OCurrencyInputComponent, ORealInputModule],
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
